import { createAction } from 'redux-actions';

export const clearGuestAuditLogs = createAction('CLEAR_GUEST_AUDIT_LOGS');
